<template>
    <div class="list-box resources-box">
        <div class="inner-wrap">
            <h3 class="cont-tit">연관 지방문화원 소장자료 (<span class="point">10</span>)</h3>
            <ul class="list"><!-- 상세페이지 지방문화원자료 카드 -->
                <li>
                    <div class="thumb">
                        <img src="https://via.placeholder.com/115x165" alt="">
                        <p class="source-origin">출처 : 한국광물자원공사</p>
                    </div>
                    <div class="data-wrap">
                        <div class="data-tit">
                            <span class="tit-txt">영산강 산이2-2공구·금호2-1공구 내부 개답공사지역 문화 유적 지표 보고</span>
                            <ul class="list-info">
                                <li>자연과 지리</li>
                                <li class="bar">시청각물</li>
                                <li class="bar">강동문화원</li>
                                <li class="bar">2018년도</li>
                            </ul>
                            <ul class="list-info">
                                <li><em>소장처 : </em>OO문화원, OO문화원, OO문화원, OO문화원</li>
                            </ul>
                        </div>
                        <p class="list-desc">일본과 가장 가까운 곳에 위치한 거제도의 일본 침탈에 대한 많은 자료 중 옥포대첩과 옥포대승 첩지 승역화사업에 대한 과정을 중점으로 소개한다. 일본과 가장 가까운 곳에 위치한 거제도의 일본 침탈에 대한 많은 자료 중 옥포대첩과 옥포대승 첩지 승역화사업에 대한 과정을 중점으로 소개한다.</p>
                        <a href="#none" class="btn-view-original">원문보기</a>
                        <a href="#none" class="btn-rectangle">RIS</a>
                    </div>
                </li>
                <li>
                    <div class="thumb">
                        <img src="https://via.placeholder.com/115x165" alt="">
                        <p class="source-origin">출처 : 한국광물자원공사</p>
                    </div>
                    <div class="data-wrap">
                        <div class="data-tit">
                            <span class="tit-txt">영산강 산이2-2공구·금호2-1공구 내부 개답공사지역 문화 유적 지표 보고</span>
                            <ul class="list-info">
                                <li>자연과 지리</li>
                                <li class="bar">시청각물</li>
                                <li class="bar">강동문화원</li>
                                <li class="bar">2018년도</li>
                            </ul>
                            <ul class="list-info">
                                <li><em>소장처 : </em>OO문화원, OO문화원, OO문화원, OO문화원</li>
                            </ul>
                        </div>
                        <p class="list-desc">일본과 가장 가까운 곳에 위치한 거제도의 일본 침탈에 대한 많은 자료 중 옥포대첩과 옥포대승 첩지 승역화사업에 대한 과정을 중점으로 소개한다. 일본과 가장 가까운 곳에 위치한 거제도의 일본 침탈에 대한 많은 자료 중 옥포대첩과 옥포대승 첩지 승역화사업에 대한 과정을 중점으로 소개한다.</p>
                        <a href="#none" class="btn-view-original">원문보기</a>
                        <a href="#none" class="btn-rectangle">RIS</a>
                    </div>
                </li>
                <li>
                    <div class="thumb">
                    </div>
                    <div class="data-wrap">
                        <div class="data-tit">
                            <span class="tit-txt">영산강 산이2-2공구·금호2-1공구 내부 개답공사지역 문화 유적 지표 보고</span>
                            <ul class="list-info">
                                <li>자연과 지리</li>
                                <li class="bar">시청각물</li>
                                <li class="bar">강동문화원</li>
                                <li class="bar">2018년도</li>
                            </ul>
                            <ul class="list-info">
                                <li><em>소장처 : </em>OO문화원, OO문화원, OO문화원, OO문화원</li>
                            </ul>
                        </div>
                        <p class="list-desc">일본과 가장 가까운 곳에 위치한 거제도의 일본 침탈에 대한 많은 자료 중 옥포대첩과 옥포대승 첩지 승역화사업에 대한 과정을 중점으로 소개한다. 일본과 가장 가까운 곳에 위치한 거제도의 일본 침탈에 대한 많은 자료 중 옥포대첩과 옥포대승 첩지 승역화사업에 대한 과정을 중점으로 소개한다.</p>
                        <a href="#none" class="btn-rectangle">RIS</a>
                    </div>
                </li>
            </ul>
            <ul class="paging">
                <li class="btn btn-first"><a href="#">처음으로</a></li>
                <li class="btn btn-prev"><a href="#">이전</a></li>
                <li class="on"><a href="#">1</a></li> <!-- 현재위치한 페이지 class on -->
                <li><a href="#">2</a></li>
                <li><a href="#">3</a></li>
                <li><a href="#">4</a></li>
                <li><a href="#">5</a></li>
                <li class="btn btn-next"><a href="#">다음</a></li>
                <li class="btn btn-last"><a href="#">맨끝으로</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        theme: { type: String },
        // relatedStories: { type: Array|Object }, // 유사 이야기자료 목록
    },
}
</script>